/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface GetMarketsRegionIdHistoryUnprocessableEntity
 */
export interface GetMarketsRegionIdHistoryUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof GetMarketsRegionIdHistoryUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the GetMarketsRegionIdHistoryUnprocessableEntity interface.
 */
export function instanceOfGetMarketsRegionIdHistoryUnprocessableEntity(value: object): value is GetMarketsRegionIdHistoryUnprocessableEntity {
    return true;
}

export function GetMarketsRegionIdHistoryUnprocessableEntityFromJSON(json: any): GetMarketsRegionIdHistoryUnprocessableEntity {
    return GetMarketsRegionIdHistoryUnprocessableEntityFromJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketsRegionIdHistoryUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetMarketsRegionIdHistoryUnprocessableEntityToJSON(json: any): GetMarketsRegionIdHistoryUnprocessableEntity {
    return GetMarketsRegionIdHistoryUnprocessableEntityToJSONTyped(json, false);
}

export function GetMarketsRegionIdHistoryUnprocessableEntityToJSONTyped(value?: GetMarketsRegionIdHistoryUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

